module.exports = __webpack_public_path__ + "images/mobile/img-invitation-letter-721512086c85ba854190f6555b3dad9f.png";